// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1sgy8","dragIcon":"SortableItem_dragIcon__T1o8W","disabled":"SortableItem_disabled__3G7Cq"};